// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "code/chunk-" + {"64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat","825":"subapps/settings"}[chunkId] + "." + {"64":"7f479da59bf8e228e74a","266":"b5beddf5551cb7288a59","757":"0a213ad5bf92094e2eae","825":"a1493e9def5820cbf9ad"}[chunkId] + ".css";
};